import { render, staticRenderFns } from "./card-info-table.vue?vue&type=template&id=c9a9cb40&scoped=true&"
import script from "./card-info-table.vue?vue&type=script&lang=js&"
export * from "./card-info-table.vue?vue&type=script&lang=js&"
import style0 from "./card-info-table.vue?vue&type=style&index=0&id=c9a9cb40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a9cb40",
  null
  
)

export default component.exports